import AccountContext from 'context/AccountContext';
import useUpdateCustomerMutation from 'hooks/useUpdateCustomerMutation';
import React, { useContext } from 'react';
import MenuToggleItem from './MenuToggleItem';

const SendEmailReceiptsMenuItem = () => {
  const {
    customer: { applicationPreferences, contactEmail },
  } = useContext(AccountContext);
  const sendEmailReceipts = applicationPreferences?.sendEmailReceipts ?? true;

  const { updateCustomer, loading } = useUpdateCustomerMutation({
    skipRefetch: true,
  });

  const onChange = (value: boolean) => {
    if (loading) {
      return;
    }
    updateCustomer({
      variables: {
        input: {
          applicationPreferences: { sendEmailReceipts: value },
        },
      },
    });
  };

  return (
    <MenuToggleItem
      value={sendEmailReceipts}
      onValueChange={onChange}
      menuLabel={'account.sendEmailReceipts'}
      testID={'send-email-receipts'}
      subtitle={contactEmail ?? undefined}
      iconName={'Email-Outlined'}
      loading={loading}
    />
  );
};

export default SendEmailReceiptsMenuItem;
